import { render } from "./PsDropdown.vue?vue&type=template&id=7d5af9ed&ts=true"
import script from "./PsDropdown.vue?vue&type=script&lang=ts"
export * from "./PsDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__